import { render, staticRenderFns } from "./ObjectDetailsModal.vue?vue&type=template&id=ebb87582&"
import script from "./ObjectDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./ObjectDetailsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports